import React from 'react';
import MDEditor from '@uiw/react-md-editor';
import { getThemeClass } from '../../../../utils/theme';

const MarkdownEditor = ({ 
  content, 
  onChange, 
  theme = 'dark' 
}) => {
  return (
    <div className="h-full flex flex-col" data-color-mode="dark">
      <div className={`flex-none px-3 py-2 border-b ${getThemeClass(theme, 'border')} 
        ${getThemeClass(theme, 'text.secondary')} text-sm font-medium`}>
        Markdown Editor
      </div>
      <div className="flex-1 min-h-0">
        <MDEditor
          value={content || ''}
          onChange={onChange}
          height="100%"
          preview="edit"
          hideToolbar={false}
          enableScroll={true}
        />
      </div>
    </div>
  );
};

export default MarkdownEditor;









